<template>
  <div class="sms-templates">
    <div class="sms-row">
      <sms-row
        v-for="(item, index) in templates"
        :key="item.id"
        :value="item"
        :index="index"
        :can-disabled="canDisabled"
        :checkboxpl="checkboxpl"
        :is-expried="isSmsExpried"
        @change="changeItem"
      />
    </div>

    <div v-if="templates.length === 0" class="sms-card">
      <span class="no-template">
        {{
          canDisabled
            ? $tr('vacancy.preferences.sms.noRemindTemplates')
            : $tr('vacancy.preferences.sms.noInviteTemplates')
        }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SmsRow from '@/routes_new/inner/vacancy/sms/components/SmsRow';

export default {
  name: 'SmsList',

  components: {
    SmsRow
  },

  props: {
    value: {
      type: [Array],
      default: () => [],
      required: true
    },

    changeItem: {
      type: Function,
      default: () => {},
      required: true
    },

    checkboxpl: {
      type: String,
      default: ''
    },

    renderTemplate: {
      type: String,
      default: ''
    },

    canDisabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('company_new', ['rates']),

    templates: {
      get() {
        return this.value || [];
      },

      set(templates) {
        this.$emit('change', templates);
      }
    },

    isSmsExpried() {
      if (!this.rates) {
        return false;
      }

      return this.rates.sms_balance <= 0 && !this.rates.is_sms_unlimited;
    }
  }
};
</script>

<style lang="scss" scoped>
.sms-templates {
  margin-bottom: 14px;
}

.sms-card {
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 14px;
  background: #fff;
  padding: 20px;
  position: relative;
}

.sms-row {
  display: flex;
  align-items: start;
  margin-bottom: 41px;
}
</style>
